import React from "react";

import twMerge from "@replo/design-system/utils/twMerge";
import { Checkbox as ShadcnCheckbox } from "@v1/components/designSystem/shadcn/core/checkbox";
import { Check } from "lucide-react";

type CheckboxProps = {
  disabled?: boolean;
  id?: string;
  onChange?: (e: boolean) => void;
  layoutClassName?: string;
  UNSAFE_className?: string;
  checked?: boolean;
  onKeyDown?: (event: React.KeyboardEvent<HTMLButtonElement>) => void;
};

const Checkbox: React.FC<CheckboxProps> = ({
  disabled = false,
  id,
  onChange,
  checked = false,
  layoutClassName,
  UNSAFE_className,
  onKeyDown,
}) => {
  return (
    <ShadcnCheckbox
      id={id}
      className={twMerge(
        "border-0.5 border-border h-4 w-4 shrink-0 cursor-pointer rounded-[4px] bg-white",
        "focus-visible:ring-primary focus-visible:ring-1 focus-visible:ring-inset focus-visible:ring-offset-0 focus-visible:ring-offset-transparent",
        checked && "bg-primary border-primary",
        disabled && "cursor-not-allowed",
        layoutClassName,
        UNSAFE_className,
      )}
      checked={checked}
      onCheckedChange={onChange}
      onKeyDown={(event) => {
        if (event.key === " ") {
          event.preventDefault();
          onChange?.(!checked);
        }
        onKeyDown?.(event);
      }}
      disabled={disabled}
      icon={
        <Check
          className="h-[10px] w-[10px] text-white"
          strokeWidth={4}
          absoluteStrokeWidth={true}
        />
      }
    />
  );
};

/** @public */
export type { CheckboxProps };
export { Checkbox };
